import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { updatePassword } from '../../api/apiAuth';
import parseError from '../../utils/parseError';

/**
 * Customer-side password change. The backend rejects with 422 +
 * `errors.current_password` when the current value is wrong; the
 * caller should bind that into Yup field errors via setError.
 *
 * Usage:
 *   const update = useUpdatePassword();
 *   update.mutate(payload, { onError: handleFieldErrors });
 */
export const useUpdatePassword = () => {
    const { t } = useTranslation();
    return useMutation({
        mutationFn: updatePassword,
        onSuccess: () => {
            toast.success(t('profile.passwordUpdated', 'Password updated'));
        },
        onError: (err) => {
            // 422 is handled inline by the form; only surface other errors.
            if (err?.response?.status !== 422) {
                toast.error(parseError(err) || t('profile.passwordUpdateError', 'Could not update password'));
            }
        },
    });
};

export default useUpdatePassword;
